import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { SideBarData } from './SideBarData'    
import * as FcIcons from 'react-icons/fc'
import * as AiIcons from 'react-icons/ai'


function SideBar() {

    const [sidemenu, setSidemenu ] = useState(false)

    const showSidebar = () => {
        setSidemenu(!sidemenu)
    }

    return (
        <div className="sidebar-container">
        <div className="sidebar">
            <Link to="#" className="menu-bars">
                <FcIcons.FcDocument onClick={showSidebar}/>
            </Link>
        </div>
        <nav className={sidemenu ? "side-menu active":"side-menu"}>
            <ul className="side-menu-items" onClick={showSidebar}>
                <li className="sidebar-toggle">
                    <Link to="#" className="menu-bars">
                        <AiIcons.AiOutlineCloseCircle />
                    </Link>
                </li>
                {SideBarData.map((item, index) => {
                    return (
                        <li key={index} className={item.cName} >
                            <Link href={item.href} to={item.path}>
                                {item.icon}
                                <span>{item.title}</span>
                            </Link>
                        </li>
                    )
                })}
            </ul>
        </nav>
        </div>
    )
}

export default SideBar
